import moment from 'moment-timezone';
import Flickity from 'flickity';
require('flickity-fullscreen');
require('flickity-as-nav-for');

export default function ticket() {
  if ($('.ticket-container').length == 0) return;

  var estTime = moment().tz("America/New_York");
  var startTime = moment.tz(show_times_of_pq.start, "YYYY-MM-DD HH:mm:ss", "America/New_York");
  var endTime = moment.tz(show_times_of_pq.end, "YYYY-MM-DD HH:mm:ss", "America/New_York");
  if (estTime.isBetween(startTime, endTime)) {
		$('#ticket-schedule .event-sessions').show();
	}

  $('.ticket-menu a').click(function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 800);
  });

  var flkty_main = new Flickity( '.fanfest-carousel-main', {
    pageDots: false,
    fullscreen: true,
  });

  var flkty_tracklayout = new Flickity( '.track-layout-slider', {
    pageDots: false,
    fullscreen: true,
  });

  $('.track-layout-slider .item').click(function(e){
    flkty_tracklayout.viewFullscreen();
  });

  // close fullscreen when click outside
  $(document).on('click', function(e){
    if (!$(e.target).closest('.track-layout-slider').length) {
      flkty_tracklayout.closeFullscreen();
    }
  });

  // close fullscreen when esc key is pressed
  $(document).on('keydown', function(e){
    if (e.key === 'Escape') {
      flkty_tracklayout.closeFullscreen();
    }
  });

  var flkty_nav = new Flickity( '.fanfest-carousel-nav', {
    asNavFor: '.fanfest-carousel-main',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
  });

  $('.fanfest-carousel-main .item img').click(function(e){
    flkty_main.viewFullscreen();
  });

  var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
  if (window.ShopifyBuy) {
    if (window.ShopifyBuy.UI) {
      ShopifyBuyInit();
    } else {
      loadScript();
    }
  } else {
    loadScript();
  }
  function loadScript() {
    var script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
    script.onload = ShopifyBuyInit;
  }
  function ShopifyBuyInit() {
    var client = ShopifyBuy.buildClient({
      domain: 'feld-experiences.myshopify.com',
      storefrontAccessToken: '36e56393006e1b9f7fb24219e4f53d60',
    });
    ShopifyBuy.UI.onReady(client).then(function (ui) {
      ui.createComponent('collection', {
        id: $('#vip-experiences').data('collection-id'),
        node: $('#vip-experiences')[0],
        moneyFormat: '%24%7B%7Bamount_no_decimals%7D%7D%20PER%20PERSON',
        options: {
          "product": {
            "styles": {
              "product": {
                "@media (min-width: 601px)": {
                  "max-width": "calc(33.33333% - 30px)",
                  "margin-left": "30px",
                  "margin-bottom": "50px",
                  "width": "calc(33.33333% - 30px)"
                },
                "img": {
                  "height": "calc(100% - 15px)",
                  "position": "absolute",
                  "left": "0",
                  "right": "0",
                  "top": "0"
                },
                "imgWrapper": {
                  "padding-top": "calc(75% + 15px)",
                  "position": "relative",
                  "height": "0"
                }
              },
              "title": {
                "color": "#000000"
              },
              "button": {
                "font-weight": "bold",
                "font-size": "16px",
                "padding-top": "16px",
                "padding-bottom": "16px",
                ":hover": {
                  "background-color": "#0866b9"
                },
                "background-color": "#0971ce",
                ":focus": {
                  "background-color": "#0866b9"
                }
              },
              "quantityInput": {
                "font-size": "16px",
                "padding-top": "16px",
                "padding-bottom": "16px"
              },
              "price": {
                "font-size": "15px",
                "color": "#000000"
              },
              "compareAt": {
                "font-size": "12.75px",
                "color": "#000000"
              },
              "unitPrice": {
                "font-size": "12.75px",
                "color": "#000000"
              }
            },
            "buttonDestination": "modal",
            "contents": {
              "options": false
            },
            "text": {
              "button": "LEARN MORE"
            }
          },
          "productSet": {
            "styles": {
              "products": {
                "@media (min-width: 601px)": {
                  "margin-left": "-30px"
                }
              }
            }
          },
          "modalProduct": {
            "contents": {
              "img": false,
              "imgWithCarousel": true,
              "button": false,
              "buttonWithQuantity": true
            },
            "styles": {
              "product": {
                "@media (min-width: 601px)": {
                  "max-width": "100%",
                  "margin-left": "0px",
                  "margin-bottom": "0px"
                }
              },
              "button": {
                "font-weight": "bold",
                "font-size": "16px",
                "padding-top": "16px",
                "padding-bottom": "16px",
                ":hover": {
                  "background-color": "#0866b9"
                },
                "background-color": "#0971ce",
                ":focus": {
                  "background-color": "#0866b9"
                }
              },
              "quantityInput": {
                "font-size": "16px",
                "padding-top": "16px",
                "padding-bottom": "16px"
              },
              "title": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "bold",
                "font-size": "26px",
                "color": "#4c4c4c"
              },
              "price": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "18px",
                "color": "#4c4c4c"
              },
              "compareAt": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "15.299999999999999px",
                "color": "#4c4c4c"
              },
              "unitPrice": {
                "font-family": "Helvetica Neue, sans-serif",
                "font-weight": "normal",
                "font-size": "15.299999999999999px",
                "color": "#4c4c4c"
              }
            },
            "text": {
              "button": "Add to cart"
            }
          },
          "option": {},
          "cart": {
            "styles": {
              "button": {
                "font-weight": "bold",
                "font-size": "16px",
                "padding-top": "16px",
                "padding-bottom": "16px",
                ":hover": {
                  "background-color": "#0866b9"
                },
                "background-color": "#0971ce",
                ":focus": {
                  "background-color": "#0866b9"
                }
              }
            },
            "text": {
              "total": "Subtotal",
              "button": "Checkout",
              "noteDescription": "Please list all participant names and ages. Additionally, if purchasing a Message Board please enter the message here. If purchasing the Birthday Experience, please enter Birthday VIP name here."
            },
            "contents": {
              "note": true
            }
          },
          "toggle": {
            "styles": {
              "toggle": {
                "font-weight": "bold",
                "background-color": "#0971ce",
                ":hover": {
                  "background-color": "#0866b9"
                },
                ":focus": {
                  "background-color": "#0866b9"
                }
              },
              "count": {
                "font-size": "16px"
              }
            }
          }
        },
      });
    });
  }
}
